




import {
  defineComponent,
  ref,
  watchEffect,
  inject,
  computed
} from '@vue/composition-api'
import { getClientId } from '@/lib/client'
import { MediaCdnKey } from '@/lib/media-cdn'

export default defineComponent({
  setup() {
    const client = ref('')

    watchEffect(() => getClientId().then(clientId => (client.value = clientId)))

    const mediaCdn = inject(MediaCdnKey)

    const clientLogoUrl = computed(() => mediaCdn.logo(client.value))
    return {
      clientLogoUrl
    }
  }
})
